function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ReactDOM, { unmountComponentAtNode } from 'react-dom';
import React from 'react';
import { Flyout } from './Flyout';
import { Popup } from './Popup';
import { Modal } from './Modal';
import { MovableContainer } from './MovableContainer';
import { Banner } from './Banner';
import { SidePanel } from './SidePanel';
import { REGISTER, TYPE } from './register';
import { ThemeProvider } from '../../util/contexts';
// expose util function for centering elements
export { getPositionForCentering } from './util';
// expose monitor function for detecting size changes
export { monitorResize, unmonitorResize } from './WindowWatcher';

/* ************************************************
 * Note! The API is not finalized and can change unexpectedly!!
 * ************************************************ */
var ID_PREFIX = 'abstract-';
var NAME = 'OskariWindowing';
export var PLACEMENTS = {
  TOP: 'top',
  BOTTOM: 'bottom',
  RIGHT: 'right',
  LEFT: 'left',
  TL: 'topLeft',
  TR: 'topRight',
  BL: 'bottomLeft',
  BR: 'bottomRight'
};
var DEFAULT_POPUP_OPTIONS = {
  isDraggable: true
};
(function (sb) {
  var module = {
    init: function init(sb) {
      sb.registerForEventByName(this, 'UIChangeEvent');
    },
    getName: function getName() {
      return NAME;
    },
    onEvent: function onEvent() {
      REGISTER.clear();
    }
  };
  sb.register(module);
})(Oskari.getSandbox());
var validate = function validate(options, type) {
  var id = options.id;
  var seq = Oskari.getSeq(NAME);
  if (!id) {
    options.id = ID_PREFIX + seq.nextVal();
  } else if (REGISTER.getExistingWindow(id, type)) {
    // attach a rolling number if we already have a window of same type and id
    var newId = id + '-' + seq.nextVal();
    options.id = newId;
    Oskari.log(NAME).warn("Popup or flyout is already added with id: ".concat(id, ", changed to: ").concat(newId));
  }
};

/**
 * Creates a root element to render a flyout/popup window into
 * @returns {HTMLElement}
 */
var createTmpContainer = function createTmpContainer() {
  var detached = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var element = document.createElement('div');
  element.classList.add('oskari-react-tmp-container');
  if (!detached) {
    document.body.appendChild(element);
  }
  return element;
};

/**
 * Creates a cleanup function for removing flyout/popup root element
 * @param {HTMLElement} flyout/popup root element
 * @param {Function} optional function to call when window is closed
 * @returns {Function}
 */
var createRemoveFn = function createRemoveFn(element, onClose) {
  var parentEl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document.body;
  var alreadyRemoved = false;
  var removeFn = function removeFn() {
    if (alreadyRemoved) {
      return;
    }
    unmountComponentAtNode(element);
    parentEl.removeChild(element);
    alreadyRemoved = true;
    if (typeof onClose === 'function') {
      onClose();
    }
  };
  return removeFn;
};

/**
 * Creates a function that can be used to modify flyout/popup order on screen.
 * @param {HTMLElement} flyout/popup root element
 * @returns {Function}
 */
var createBringToTop = function createBringToTop(element) {
  return function () {
    if (document.body.lastChild !== element) {
      document.body.appendChild(element);
    }
  };
};

/**
 * Opens a an Oskari popup type of window.
 * Usage:
 *
 *       let popupController = null;
 *       btn.on('click', (event) => {
 *           if (popupController) {
 *               popupController.close();
 *               return;
 *           }
 *           popupController = showPopup('Title', 'Content', () => {
 *               // closed -> cleanup
 *               popupController = null;
 *           });
 *       });
 *
 * @param {String} title title for popup
 * @param {String|ReactElement} content content for popup
 * @param {Function} onClose callback that is called when the window closes
 * @param {Object} options (optional) to override default options
 * @returns {Object} that provides functions that can be used to close/update the popup
 */
export var showPopup = function showPopup(title, content, onClose) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  validate(options, TYPE.POPUP);
  var element = createTmpContainer();
  var key = REGISTER.registerWindow(options.id, TYPE.POPUP, createRemoveFn(element, onClose));
  var removeWindow = function removeWindow() {
    return REGISTER.clear(key);
  };
  var bringToTop = createBringToTop(element);
  var opts = _objectSpread(_objectSpread({}, DEFAULT_POPUP_OPTIONS), options);
  var render = function render(title, content) {
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, {
      value: options.theme
    }, /*#__PURE__*/React.createElement(Popup, {
      title: title,
      onClose: removeWindow,
      bringToTop: bringToTop,
      options: opts
    }, content)), element);
  };
  render(title, content);
  return {
    update: render,
    close: removeWindow,
    bringToTop: bringToTop
  };
};

/**
 * Opens given content as modal
 * Usage:
 *
 *       let modalController = null;
 *       btn.on('click', (event) => {
 *           if (modalController) {
 *               modalController.close();
 *               return;
 *           }
 *           modalController = showModal('Title', 'Content', () => {
 *               // closed -> cleanup
 *               modalController = null;
 *           });
 *       });
 *
 * @param {String} title title for modal
 * @param {String|ReactElement} content content for modal
 * @param {Function} onClose callback that is called when the window closes
 * @param {Object} options (optional) to override default options
 * @returns {Object} that provides functions that can be used to close/update the modal
 */
export var showModal = function showModal(title, content, onClose) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  validate(options, TYPE.MODAL);
  var element = createTmpContainer();
  var key = REGISTER.registerWindow(options.id, TYPE.MODAL, createRemoveFn(element, onClose));
  var removeWindow = function removeWindow() {
    return REGISTER.clear(key);
  };
  var bringToTop = createBringToTop(element);
  var opts = _objectSpread({}, options);
  var render = function render(content) {
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, {
      value: options.theme
    }, /*#__PURE__*/React.createElement(Modal, {
      title: title,
      options: opts
    }, content)), element);
  };
  render(content);
  return {
    update: render,
    close: removeWindow,
    bringToTop: bringToTop
  };
};

/**
 * Creates a movable container that is similar to popup and flyout but without any frames on the window.
 * Usage:
 *
 *       let containerController = null;
 *       btn.on('click', (event) => {
 *           if (containerController) {
 *               containerController.close();
 *               return;
 *           }
 *           containerController = showMovableContainer(<SomeJSX />, () => {
 *               // closed -> cleanup
 *               containerController = null;
 *           });
 *       });
 *
 * @param {String|ReactElement} content content for flyout
 * @param {Function} onClose callback that is called when the window closes
 * @param {Object} options (optional) to override default options
 * @returns {Object} that provides functions that can be used to close/update the flyout
 */
export var showMovableContainer = function showMovableContainer(content, onClose) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  validate(options, TYPE.CONTAINER);
  var element = createTmpContainer();
  var key = REGISTER.registerWindow(options.id, TYPE.CONTAINER, createRemoveFn(element, onClose));
  var removeWindow = function removeWindow() {
    return REGISTER.clear(key);
  };
  var bringToTop = createBringToTop(element);
  var opts = _objectSpread({
    isDraggable: true
  }, options);
  var render = function render(content) {
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, {
      value: options.theme
    }, /*#__PURE__*/React.createElement(MovableContainer, {
      onClose: removeWindow,
      bringToTop: bringToTop,
      options: opts
    }, content)), element);
  };
  render(content);
  return {
    update: render,
    close: removeWindow,
    bringToTop: bringToTop
  };
};

/**
 * Opens an Oskari flyout type of window.
 * Usage:
 *
 *       let popupController = null;
 *       btn.on('click', (event) => {
 *           if (popupController) {
 *               popupController.close();
 *               return;
 *           }
 *           popupController = showFlyout('Title', 'Content', () => {
 *               // closed -> cleanup
 *               popupController = null;
 *           });
 *       });
 *
 * @param {String} title title for flyout
 * @param {String|ReactElement} content content for flyout
 * @param {Function} onClose callback that is called when the window closes
 * @param {Object} options (optional) to override default options
 * @returns {Object} that provides functions that can be used to close/update the flyout
 */
export var showFlyout = function showFlyout(title, content, onClose) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  validate(options, TYPE.FLYOUT);
  var element = createTmpContainer();
  var key = REGISTER.registerWindow(options.id, TYPE.FLYOUT, createRemoveFn(element, onClose));
  var removeWindow = function removeWindow() {
    return REGISTER.clear(key);
  };
  var bringToTop = createBringToTop(element);
  var render = function render(title, content) {
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(Flyout, {
      title: title,
      onClose: removeWindow,
      bringToTop: bringToTop,
      options: options
    }, content)), element);
  };
  render(title, content);
  return {
    update: render,
    close: removeWindow,
    bringToTop: bringToTop
  };
};
export var showSidePanel = function showSidePanel(title, content, onClose) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  validate(options, TYPE.SIDE_PANEL);
  var root = Oskari.dom.getRootEl();
  // create detached element instead of one attached to body
  var element = createTmpContainer(true);
  // add element to root directly as side panel
  root.prepend(element);
  var nav;
  root.childNodes.forEach(function (node) {
    if (node.localName === 'nav') {
      nav = node;
    }
  });
  var key = REGISTER.registerWindow(options.id, TYPE.SIDE_PANEL, createRemoveFn(element, onClose, root));
  var removeWindow = function removeWindow() {
    REGISTER.clear(key);
    if (nav) {
      nav.style.display = 'block';
    }
  };
  root.prepend(element);
  var render = function render(title, content) {
    if (nav) {
      nav.style.display = 'none';
    }
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(SidePanel, {
      title: title,
      onClose: removeWindow,
      options: options
    }, content)), element);
  };
  render(title, content);
  return {
    update: render,
    close: removeWindow
  };
};

/**
 * Opens a banner on top of the screen.
 *
 * @param {ReactNode} content
 * @param {Function} onClose callback that is called when the window closes
 * @param {Object} options (optional) to override default options
 * @returns {object} that provides functions that can be used to close/update the banner
 */
export var showBanner = function showBanner(content, onClose) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  validate(options, TYPE.BANNER);
  var element = createTmpContainer();
  var key = REGISTER.registerWindow(options.id, TYPE.BANNER, createRemoveFn(element, onClose));
  var removeWindow = function removeWindow() {
    return REGISTER.clear(key);
  };
  var bringToTop = createBringToTop(element);
  var render = function render(content) {
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(Banner, {
      onClose: removeWindow,
      options: options
    }, content)), element);
  };
  render(content);
  return {
    update: render,
    close: removeWindow,
    bringToTop: bringToTop
  };
};
export var getNavigationDimensions = function getNavigationDimensions() {
  var nav = _toConsumableArray(Oskari.dom.getRootEl().children).find(function (c) {
    return c.localName === 'nav';
  });
  if (!nav) {
    return {
      top: 0,
      left: 0,
      width: 0,
      height: 0,
      right: 0,
      bottom: 0
    };
  }
  var values = {
    top: nav.offsetTop,
    left: nav.offsetLeft,
    width: Oskari.dom.getWidth(nav),
    height: Oskari.dom.getHeight(nav)
  };
  values.right = nav.offsetLeft + values.width;
  values.bottom = nav.offsetTop + values.height;
  var placement = PLACEMENTS.LEFT;
  if (values.left > 0) {
    placement = PLACEMENTS.RIGHT;
  } else if (values.width > values.height) {
    if (values.top > 0) {
      placement = PLACEMENTS.BOTTOM;
    } else {
      placement = PLACEMENTS.TOP;
    }
  }
  return _objectSpread(_objectSpread({}, values), {}, {
    placement: placement
  });
};